import PeopleAlphaButtons from './PeopleAlphaButtons';

export { type PeopleAlphaButtonsProps } from './PeopleAlphaButtons';
export default PeopleAlphaButtons;
